import Grid from "@material-ui/core/Grid";
import { InputSelect } from "../../../../../components/input-select/InputSelect";
import MenuItem from "@material-ui/core/MenuItem";
import { useEffect, useState } from "react";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from "yup";
import { FormattedMessage, useIntl } from "react-intl";
import ICIPAdminService from "../../../../../services/ICIPAdminService";
import { InputField } from "../../../../../components/input-field/InputField";
import { InputButton } from "../../../../../components/input-button/InputButton";
import {
  CircularProgress,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { Delete } from "@material-ui/icons";

const useStyles = makeStyles((_) => ({
  blocGrid: {
    border: "2px solid",
    margin: 10,
    padding: 15,
  },
  inputGrid: {
    padding: 5,
  },
  generalGrid: {
    padding: 10,
  },
  buttonsContain: {
    display: "flex",
    alignItems: "center",
    margin: 10,
    //padding: 15,
  },
  tableHead: {
    width: "45%",
    fontWeight: "bold",
    textAlign: "center",
    border: "solid 1px",
  },
  tableData: {
    width: "45%",
    textAlign: "center",
    border: "solid 1px",
  },
  customTable: {
    width: "90%",
  },
  deleteButton: {
    verticalAlign: "center",
    position: "relative",
    //position: "absolute",
    top: "50%",
    textAlign: "right",
    msTransform: "translateY(35%)",
    transform: "translateY(35%)",
  },
  packageName: {
    fontWeight: "bold",
  },
  tabHeading: {
    fontWeight: "bold",
    fontSize: 14,
  },
  newButton: {
    //textTransform: "none",
    fontSize: 13,
  },
  subButton: {
    textTransform: "none",
    fontSize: 10,
    width: 100,
  },
  exportButton: {
    width: 175,
    alignContent: "left",
  },
  contentListParticipant: {
    padding: 50,
  },
}));

export const SpecialRaffleDrawInProgress = () => {
  const classes = useStyles();
  const [winningPackages, setWinningPackages] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const { formatMessage } = useIntl();
  const [packageWinnersInfos, setPackageWinnersInfos] = useState([]);
  const [
    specialRaffleDrawInProgress,
    setSpecialRaffleDrawInProgress,
  ] = useState({});
  const [raffleNumberOfPackage, setRaffleNumberOfPackage] = useState(0);
  const [winnersInfoTab, setWinnersInfoTab] = useState([]);

  const formik = useFormik({
    initialValues: {
      id: 0,
    },
    validationSchema: Yup.object().shape({}),
    onSubmit: async (values, { setSubmitting }: FormikHelpers<any>) => {
      setError(false);
      try {
        ICIPAdminService.getWinningPackages().then((response) => {
          if (response.isSuccess) {
            switch (response.data.code) {
              case 100:
                const winningPackages = JSON.parse(
                  JSON.stringify(response.data.data)
                );
                console.log(winningPackages);
                setWinningPackages(winningPackages);
                break;
              case 110:
                setError(true);
                break;
            }
          } else {
            setError(true);
          }
          //setLoading(false);
        });
      } catch (error) {
        setError(true);
      }
      setSubmitting(false);
    },
  });

  const fetchWinningPackagesList = () => {
    ICIPAdminService.getWinningPackages().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const winningPackages = JSON.parse(
              JSON.stringify(response.data.data)
            );
            for (let index = 0; index < winningPackages.length; index++) {
              if (winningPackages[index].code === "QATAR_TRAVEL") {
                winningPackages.splice(index, 1);
              }
            }
            setWinningPackages(winningPackages);
            break;
          case 110:
            setError(true);
            break;
        }
      } else {
        setError(true);
      }
      //setLoading(false);
    });
  };

    const loadRaffleDrawInProgress = () => {
        setLoading(true);
        ICIPAdminService.getSpecialRaffleDrawInProgress().then((response) => {
            if(response.isSuccess && response.data.code === 100){
                const data = JSON.parse(JSON.stringify(response.data.data));
                setSpecialRaffleDrawInProgress(data["raffleDrawInProgress"]);
               
            }
            setLoading(false);
        });
    }

    const loadfirstBox = () => {
        let packageWinner = {};
        packageWinner["winning_package_id"] = "";
        packageWinner["number_of_winners"] = "";

        setPackageWinnersInfos([packageWinner]);
    }

    useEffect(() => {
        fetchWinningPackagesList();
        loadRaffleDrawInProgress();
        loadfirstBox();
    },[]);

    const handleChangeOfPackage = (index: number, packageId: string) =>{
        let currentPackageWinnersInfos = [...packageWinnersInfos];
        currentPackageWinnersInfos[index]["winning_package_id"] = parseInt(packageId);
        setPackageWinnersInfos(currentPackageWinnersInfos);
    }

    const handleChangeNumberOfWinner = (index: number, numberOfWinners: string) =>{
        let currentPackageWinnersInfos = [...packageWinnersInfos];
        currentPackageWinnersInfos[index]["number_of_winners"] = parseInt(numberOfWinners);
        setPackageWinnersInfos(currentPackageWinnersInfos);
    }

    const deletePackageWinner = (index: number) =>{
        let currentPackageWinnersInfos = [...packageWinnersInfos];
        currentPackageWinnersInfos.splice(index,1);
        setPackageWinnersInfos(currentPackageWinnersInfos);
    }

    const addPackageWinner = () => {
        //let numberOfPackages = packageWinnersInfos.length;
        let currentPackageWinnersInfos = [...packageWinnersInfos];
        let packageWinner = {};
        packageWinner["winning_package_id"] = "";
        packageWinner["number_of_winners"] = "";
        currentPackageWinnersInfos.push(packageWinner);
        setPackageWinnersInfos(currentPackageWinnersInfos);
    }

    const generateWinners = () => {
        //setSavingWinners(true);
        const existEmpty = haveEmptyValues();
        setLoadingBtn(true);
        if(!existEmpty){
            ICIPAdminService.generateWinners(specialRaffleDrawInProgress["id"], packageWinnersInfos).then((response) => {
                const resultData = JSON.parse(JSON.stringify(response.data));
                //const tabResult = Object.values(resultData);
                setWinnersInfoTab(resultData);
                setLoadingBtn(false);
            })
        }else{
            setLoadingBtn(false);
            alert('veuillez remplir tous les champs')
        }
    }

    const haveEmptyValues = () => {
        let currentPackageWinnersInfos = [...packageWinnersInfos];
        let result = false
        currentPackageWinnersInfos.forEach(packageWinnersInfos => {
            if(packageWinnersInfos['winning_package_id'] === "" || packageWinnersInfos['number_of_winners'] === ""){
                result = true;
            }
        })

        return result;
    }

   
  return (
    <Grid container>
      <Grid item xs={6} sm={6} lg={6}>
        {loading && <CircularProgress />}
        <Grid className={classes.generalGrid} xs={12} sm={12} lg={12}>
          <Typography variant="h4" component="h4">
            <FormattedMessage id="sharedScreen.raffleDrawInProgress" />
            {specialRaffleDrawInProgress != null &&
              (` ${specialRaffleDrawInProgress["raffle_draw_date"]}` || "")}
          </Typography>
        </Grid>
        {packageWinnersInfos.map((packageWinnerInfo, index) => {
          return (
            <>
              <Grid
                container
                className={classes.blocGrid}
                xs={10}
                sm={10}
                lg={10}
              >
                <Grid className={classes.inputGrid} item xs={12} sm={12} lg={6}>
                  <InputSelect
                    fullWidth
                    id="designation_fr"
                    name="designation_fr"
                    value={packageWinnerInfo["winning_package_id"]}
                    label={formatMessage({
                      id: "sharedScreen.package",
                    })}
                    placeholder={formatMessage({
                      id: "sharedScreen.package",
                    })}
                    onChange={(event) =>
                      handleChangeOfPackage(index, event.target.value)
                    }
                    error={
                      Boolean(packageWinnerInfo.designation_fr) &&
                      Boolean(packageWinnerInfo.designation_fr)
                    }
                    helperText={
                      packageWinnerInfo.designation_fr &&
                      packageWinnerInfo.designation_fr
                    }
                  >
                    <MenuItem>
                      <FormattedMessage id="sharedScreen.package" />
                    </MenuItem>
                    {winningPackages.map((winningPackage, index) => {
                      return (
                        <MenuItem value={winningPackage.id}>
                          {winningPackage.designation_fr}
                        </MenuItem>
                      );
                    })}
                  </InputSelect>
                </Grid>
                <Grid className={classes.inputGrid} item xs={12} sm={12} lg={5}>
                  <InputField
                    value={packageWinnerInfo["number_of_winners"]}
                    type="number"
                    fullWidth
                    placeholder={formatMessage({
                      id: "sharedScreen.numberOfWinner",
                    })}
                    label={formatMessage({
                      id: "sharedScreen.numberOfWinner",
                    })}
                    name="number_of_winner"
                    onChange={(event) =>
                      handleChangeNumberOfWinner(index, event.target.value)
                    }
                    error={
                      formik.touched.number_of_winner &&
                      Boolean(formik.errors.number_of_winner)
                    }
                    helperText={
                      formik.touched.number_of_winner &&
                      formik.errors.number_of_winner
                    }
                  />
                </Grid>
                <Grid
                  className={classes.deleteButton}
                  item
                  xs={2}
                  sm={2}
                  lg={1}
                >
                  <IconButton
                    aria-label="delete"
                    size="medium"
                    onClick={(event) => deletePackageWinner(index)}
                  >
                    <Delete fontSize="inherit" color="error" />
                  </IconButton>
                </Grid>
              </Grid>
            </>
          );
        })}

        <Grid
          container
          className={classes.buttonsContain}
          item
          xs={10}
          sm={10}
          lg={10}
        >
          <Grid className={classes.inputGrid} item xs={6} sm={6} lg={6}>
            <InputButton
              type="submit"
              fullWidth
              variant="contained"
              color="secondary"
              onClick={(event) => addPackageWinner()}
            >
              <FormattedMessage id="sharedScreen.plus" />
              {formik.isSubmitting && <CircularProgress size={30} />}
            </InputButton>
          </Grid>

          <Grid className={classes.inputGrid} item xs={6} sm={6} lg={6}>
            {!loadingBtn ? (
              <InputButton
                type="submit"
                fullWidth
                variant="contained"
                color="secondary"
                onClick={generateWinners}
              >
                <FormattedMessage id="sharedScreen.generate" />
                {formik.isSubmitting && <CircularProgress size={30} />}
              </InputButton>
            ) : (
              <CircularProgress />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6} sm={6} lg={6}>
        <Grid className={classes.generalGrid} xs={12} sm={12} lg={12}>
          <Typography variant="h4" component="h4">
            <FormattedMessage id="sharedScreen.specialraffleDrawWinners" />
          </Typography>
        </Grid>
        <table className={classes.customTable}>
          <thead>
            <th className={classes.tableHead}>
              {formatMessage({ id: "sharedScreen.name" })}
            </th>
            <th className={classes.tableHead}>
              {formatMessage({ id: "sharedScreen.phone" })}
            </th>
          </thead>
          <tbody>
            {Object.keys(winnersInfoTab).map((key) => {
              return (
                <>
                  <tr>
                    <td className={classes.packageName} colSpan={2}>
                      {key} - {winnersInfoTab[key]["amount"]}{" "}
                      {winnersInfoTab[key]["currency"]}
                    </td>
                  </tr>
                  {winnersInfoTab[key]["info"].map((winnerInfo, index2) => {
                    return (
                      <tr>
                        <td className={classes.tableData}>
                          {winnerInfo["name"]}
                        </td>
                        <td className={classes.tableData}>
                          {winnerInfo["phoneNumber"]}
                        </td>
                      </tr>
                    );
                  })}
                </>
              );
            })}
          </tbody>
        </table>
      </Grid>
    </Grid>
  );
};

export default SpecialRaffleDrawInProgress;
